
import React, { ReactNode } from 'react';

import backgroundLogo from '../../../assets/koop-draft-logo.png';

interface LoginLayoutProps {
	children: ReactNode;
}

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
	return (
		// <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }} className="login-container">
		<div className="login-main">
			<div className='login-container'>

				< div className="center-middle login-side1" >
					<div className="vertical-middle login-logo">
						<div>
							<a href='/'>
								<img style={{ width: "100px", height: "100px", objectFit: "contain" }} src={backgroundLogo} />
							</a>
						</div>
						<div className=" koop">
							KOOP BATANGAN MPC
						</div>
						<div className=" font-size-17px">
							LOAN MANAGEMENT
						</div>
					</div>
					<div className="copyright-font">
						2024 © DVIA Solutions
					</div>

				</div >
				<div className="login-half">

					<div className=" width-height-100 login-box">



						{children}



					</div>
				</div>
			</div>

			<div className="copyright-font copyright-mobile">
				2024 © DVIA Solutions
			</div>
		</div >
	);
};

export default LoginLayout;